(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/search-overlay.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/search-overlay.js');
"use strict";


const {
  shouldShowOverlayAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  useAtom
} = jotai;
const SearchOverlay = () => {
  const [shouldShowOverlay, setShouldShowOverlay] = useAtom(shouldShowOverlayAtom);
  if (!shouldShowOverlay) {
    return null;
  }
  return React.createElement("div", {
    style: {
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: 0,
      left: 0
    },
    onClick: () => {
      setShouldShowOverlay(false);
    }
  });
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  SearchOverlay
});

 })(window);